<template>
  <div class="mail-template-list">
    <div class="list-table__title">Mail Template list</div>
    <b-table
      striped
      hover
      fixed
      Outlined
      show-empty
      :empty-text="'No data available'"
      :items="templates"
      :fields="fields"
      :table-class="'list-table text-center'"
      :thead-class="'list-table__head'"
      :tbody-class="'list-table__body'"
    >
      <template #cell(Detail)="mail">
        <div>
          <b-button pill variant="outline-secondary" class="mb-1"
            :to="{
              name: 'MailTemplateEdit',
              params: { mailTemplateId: mail.item.id },
            }"
          >
            Edit
          </b-button>
          <b-button pill variant="outline-secondary"
            :to="{
              name: 'MailTemplateCopy',
              params: { mailTemplateId: mail.item.id },
            }"
          >
            Copy
          </b-button>
        </div>
      </template>
    </b-table>
  </div>
</template>

<script lang="ts">
import { Moment } from 'moment'
import { Component, Prop, Vue } from 'vue-property-decorator'
import { MailTemplate } from '@/store/mails/templates/types'

@Component
export default class MailTemplateTable extends Vue {
  @Prop() templates!: MailTemplate[]

  private fields = [
    {
      key: 'id',
      label: 'Mail Template ID',
    },
    {
      key: 'name',
      label: 'Mail Template Name',
    },
    {
      key: 'subject',
      label: 'Subject',
    },
    {
      key: 'created',
      label: 'Created',
      formatter: (created: Moment) => created && created.format('YYYY/MM/DD'),
    },
    {
      key: 'updated',
      label: 'Updated',
      formatter: (updated: Moment) => updated && updated.format('YYYY/MM/DD'),
    },
    { key: 'Detail' },
  ]
}
</script>

<style>
.mail-template-list .list-table .list-table__head {
  font-size: .7rem;
}

.mail-template-list .list-table .list-table__body td {
  font-size: .7rem;
}

.mail-template-list .btn {
  min-width: 80px;
  padding: 10px 20px;
  font-size: 1rem;
  line-height: .5;
}
</style>

<style scoped>
.detail-button {
  display: block;
  text-decoration: none;
  color: #000;
  padding: 10px;
  border: 2px solid #AAAFB6;
  border-radius: 20px;
  cursor: pointer;
};

.detail-button:hover {
  background: #000;
};
</style>
